export function convertUnixEpochToDate(unixEpochTime: number) {
  const date = new Date(unixEpochTime * 1000);

  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
}
